import { graphql } from 'react-relay';
import { genericMutation, useGenericMutation } from '../utils';
import type { Znglist_AddContent_Mutation } from './__generated__/Znglist_AddContent_Mutation.graphql';
import type { Znglist_Create_Mutation } from './__generated__/Znglist_Create_Mutation.graphql';
import type { Znglist_Delete_Mutation } from './__generated__/Znglist_Delete_Mutation.graphql';
import type { Znglist_Duplicate_Mutation } from './__generated__/Znglist_Duplicate_Mutation.graphql';
import type { Znglist_UpdateZnglistOrder_Mutation } from './__generated__/Znglist_UpdateZnglistOrder_Mutation.graphql';
import type { Znglist_UpdateZnglist_Mutation } from './__generated__/Znglist_UpdateZnglist_Mutation.graphql';

const UpdateZnglistContentMutation = graphql`
  mutation Znglist_AddContent_Mutation($input: UpdateZnglistInput!) {
    updateZnglist(input: $input) {
      znglist {
        id
        znglist {
          ...Znglist_ZnglyContents_Fragment @relay(mask: false)
        }
      }
    }
  }
`;

export const addZnglistContentMutation = genericMutation<Znglist_AddContent_Mutation>({
  mutation: UpdateZnglistContentMutation,
});

const UpdateZnglistMutation = graphql`
  mutation Znglist_UpdateZnglist_Mutation($input: UpdateZnglistInput!)  {
    updateZnglist(input: $input) {
      znglist {
        ...Znglist_Fragment @relay(mask: false)

      }
    }
  }
`;

export const updateZnglistMutation = genericMutation<Znglist_UpdateZnglist_Mutation>({
  mutation: UpdateZnglistMutation,
});

export const useUpdateZnglistMutation = useGenericMutation<Znglist_UpdateZnglist_Mutation>(updateZnglistMutation);

const UpdateZnglistOrderMutation = graphql`
  mutation Znglist_UpdateZnglistOrder_Mutation($input: UpdateZnglistInput!) @raw_response_type {
    updateZnglist(input: $input) {
      znglist {
        id
        znglist {
          order
        }
      }
    }
  }
`;

export const updateZnglistOrderMutation = genericMutation<Znglist_UpdateZnglistOrder_Mutation>(({ input }) => ({
  mutation: UpdateZnglistOrderMutation,
  optimisticResponse: {
    updateZnglist: {
      znglist: {
        id: input.id,
        znglist: {
          order: input?.order,
        },
      },
    },
  },
}));

export * from './__generated__/Znglist_Create_Mutation.graphql';
const CreateZnglistMutation = graphql`
  mutation Znglist_Create_Mutation(
    $input: CreateZnglistInput!
    $connections: [ID!]! # needed for @prependNode directive
  ) {
    createZnglist(input: $input) {
      znglist @prependNode(connections: $connections, edgeTypeName: "Znglist") {
        id
        title
        status
        date
        modified
        author {
          ...Frags_With_Author_Fragment @relay(mask: false)
        }
      }
    }
  }
`;

export const createZnglistMutation = genericMutation<Znglist_Create_Mutation>({
  mutation: CreateZnglistMutation,
});

export * from './__generated__/Znglist_Delete_Mutation.graphql';
export const DeleteZnglistMutation = graphql`
  mutation Znglist_Delete_Mutation($input: DeleteZnglistInput!) @raw_response_type {
    deleteZnglist(input: $input) {
      deletedId @deleteRecord
    }
  }
`;

export const deleteZnglistMutation = genericMutation<Znglist_Delete_Mutation>(({ input }) => ({
  mutation: DeleteZnglistMutation,
  optimisticResponse: {
    deleteZnglist: {
      deletedId: input.id,
    },
  },
}));

export type {
  Znglist_Duplicate_Mutation,
  Znglist_Duplicate_Mutation$data,
  Znglist_Duplicate_Mutation$variables,
} from './__generated__/Znglist_Duplicate_Mutation.graphql';
const DuplicateZnglistMutation = graphql`
  mutation Znglist_Duplicate_Mutation($input: DuplicateZnglistInput!, $connections: [ID!]! # needed for @prependNode directive
) {
    duplicateZnglist(input: $input) {
      znglist @prependNode(connections: $connections, edgeTypeName: "Znglist") {
        ...Znglist_Fragment @relay(mask: false)
      }
    }
  }
`;

export const duplicateZnglistMutation = genericMutation<Znglist_Duplicate_Mutation>({
  mutation: DuplicateZnglistMutation,
});
